import React from "react";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { experienceData } from "./experiecneData";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Typography from '@mui/material/Typography';
import './Timeline.scss';

const Timeline = () => {

    const [ isExpand, doExpand ] = React.useState(false);
    const [ key, setKey ] = React.useState(null);

    const expand = (index) => {
        doExpand(!isExpand);
        setKey(index);
    }

    return (

        <VerticalTimeline>

            {
                experienceData.map((experience, index) => (
                    <VerticalTimelineElement
                        key={index}
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'whitesmoke', color: 'black' }}
                        contentArrowStyle={{ borderRight: '7px solid  whitesmoke' }}
                        date={experience.date}
                        iconStyle={{ background: '#ffc86d', color: 'whitesmoke' }}
                        icon={<i className="fas fa-code"></i>}
                    >

                        <div className="timeline-header">

                            <div className="time-line-heading">
                                <h5 className="vertical-timeline-element-title">{experience.company}</h5>
                                <h6 className="vertical-timeline-element-subtitle">{experience.title}</h6>
                            </div>

                            <button className="show-more" onClick={() => {
                                expand(index)
                            }}>
                                <ArrowBackIosIcon className={isExpand && key===index ? "arrow-up" : "arrow-down"} />
                            </button>
                        </div>

                        <Typography 
                            variant="body2" 
                            color="text.secondary"
                            className="timeline-para"
                            style={{
                                    display: isExpand && key===index ? "block" : "none",
                                }
                            }
                        >
                            {experience.description}
                        </Typography>
                    </VerticalTimelineElement>
                ))
            }
                
        </VerticalTimeline>
    );
}

export default Timeline;